<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay">
      <div class="modal-window">
        <div class="hw-modal-wrap modal-content">
          <div class="hw-modal-header">{{ privacyDocList[0].title }}</div>

          <div class="hw-modal-body">
            <p class="body-desc">
              {{
                `'(주)가비아'는 플러스앱에 게시된 제휴서비스 연동을 위해 다음과 같이 개인정보를 '${privacyDocList[0].contents.recipient[0]}'에 제공합니다.`
              }}
            </p>

            <div class="privacy">
              <div class="privacy-content">
                <p class="privacy-content__title">1. 개인정보를 제공받는 자</p>
                <p class="privacy-content__desc">{{ privacyDocList[0].contents.recipient[0] }}</p>
              </div>

              <div class="privacy-content">
                <p class="privacy-content__title">2. 개인정보 제공 목적</p>
                <p class="privacy-content__desc">{{ privacyDocList[0].contents.propose[0] }}</p>
              </div>

              <div class="privacy-content">
                <p class="privacy-content__title">3. 개인정보 제공 항목</p>
                <p class="privacy-content__desc">{{ privacyDocList[0].contents.items.join(', ') }}</p>
              </div>

              <div class="privacy-content">
                <p class="privacy-content__title">4. 개인정보를 제공 받는 자의 보유 및 이용기간</p>
                <p class="privacy-content__desc">{{ privacyDocList[0].contents.retention[0] }}</p>
              </div>
            </div>

            <p class="body-desc">동의를 거부하는 경우 플러스앱을 통한 제휴 서비스 연동이 제한될 수 있습니다.</p>

            <div class="check-area">
              <input type="checkbox" id="private-checkbox" v-model="checked" />
              <label for="private-checkbox">개인정보 제3자 제공 동의(필수)</label>
            </div>
          </div>

          <div class="hw-modal-footer">
            <button type="button" class="hw-button secondary" @click="close">{{ $t('CLOSE') }}</button>
            <button type="button" class="hw-button primary" :disabled="!checked" @click="clickAccept">
              {{ '동의' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PrivacyCheckDialog',
  props: {
    selectedPlusApp: {
      type: Object,
    },
    privacyDocList: {
      type: Array,
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    close() {
      this.$emit('close-plus-privacy-check-dialog');
    },
    clickAccept() {
      this.$emit('click-accept-plus-app-privacy', this.selectedPlusApp);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/style';

.hw-button {
  display: inline-block;
  background-color: $primary-color;
  border: 1px solid $primary-color-hover;
  border-radius: 4px;
  color: #fff;
  padding: 5px 20px 6px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  transition-duration: 0.1s;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  //hover
  &:hover,
  &:focus {
    color: #fff;
    background: darken($primary-color-hover, 10%);
    border-color: darken($primary-color-hover, 10%);
    outline: none;
  }

  //disabled
  &[disabled],
  &:disabled {
    cursor: default;
    opacity: 0.5;
    &:hover {
      background: $primary-color;
      border-color: $primary-color-hover;
    }
  }

  &.secondary {
    background-color: $secondary-color;
    border-color: $secondary-color-hover;
    color: #333;
    &:hover,
    &:focus {
      background-color: $secondary-color-hover;
      border-color: $secondary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $secondary-color;
        border-color: $secondary-color-hover;
      }
    }
  }

  &.info {
    background-color: $info-color;
    border-color: $info-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $info-color-hover;
      border-color: $info-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $info-color;
        border-color: $info-color-hover;
      }
    }
  }

  &.warning {
    background-color: $warning-color;
    border-color: $warning-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $warning-color-hover;
      border-color: $warning-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $warning-color;
        border-color: $warning-color-hover;
      }
    }
  }

  &.danger {
    background-color: $danger-color;
    border-color: $danger-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $danger-color-hover;
      border-color: $danger-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $danger-color;
        border-color: $danger-color-hover;
      }
    }
  }

  &.text {
    color: $primary-color;
    padding: 0 10px;
    background: transparent;
    border-color: transparent;
    //hover
    &:hover,
    &:focus {
      color: $primary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        color: $primary-color;
        background: transparent;
        border-color: transparent;
        opacity: 0.5;
      }
    }
  }

  &.outline-blue {
    background-color: #fff;
    border: 1px solid #c8c8c8;
    color: #2c86dc;
    &:hover {
      border-color: #2c86dc;
    }
  }

  &.outline-gray {
    background: #f1f1f1;
    border: 1px solid #c8c8c8;
    color: #444;
    &:hover {
      border-color: #8c8c8c;
    }
  }

  &.outline-gray2 {
    background: #fff;
    border: 1px solid #d6d6d6;
    color: #333;
    padding-left: 12px;
    padding-right: 12px;
    > i {
      color: #909090;
      float: right;
      margin-top: 4px;
      margin-left: 10px;
    }
    &:hover {
      background: #f6f6f6;
    }
    &:focus {
      > i {
        color: #575757;
      }
    }
    &[disabled],
    &:disabled {
      border-color: #f2f2f2;
      background: #ffffff;
      &,
      > i {
        color: #d0d0d0;
      }
    }
  }

  &.rounded {
    border-radius: 4px;
  }

  //이웃하는 버튼 간격
  & + .hw-button {
    margin-left: 14px;
  }
}

.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
  }

  &-window {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    width: calc(100% - 20px);
    max-height: 80vh;

    @media (min-width: 900px) {
      width: 600px;
    }

    .hw-modal-wrap {
      width: 100%;
    }
  }

  &-content {
    padding: 10px 20px;
    overflow: auto;
  }

  &-footer {
    background: #ccc;
    padding: 10px;
    text-align: right;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s;

  .modal-window {
    transition: opacity 0.2s, transform 0.2s;
  }
}

.modal-leave-active {
  transition: opacity 0.2s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.hw-modal-header {
  padding-bottom: 20px;
  border-bottom: 1px solid #d6d6d6;
  font-size: 16px;
}

.hw-modal-body {
  padding-top: 20px;
  font-size: 14px;
  overflow-y: auto;

  .body-desc {
    color: #131313;
    font-size: 14px;
  }

  .privacy {
    width: 100%;
    background-color: #f7f7f7;
    padding: 20px;
    margin: 20px 0;
    font-size: 14px;

    &-content:not(:last-child) {
      padding-bottom: 20px;
    }
    &-content {
      &__title {
        color: #131313;
        font-weight: bold;
        padding-bottom: 4px;
      }
    }
  }

  .check-area {
    display: flex;
    align-items: center;
    padding-top: 16px;
    #private-checkbox {
      &:hover {
        cursor: pointer;
      }
    }
    > label {
      margin-left: 10px;
      color: #707070;
      &:hover {
        cursor: pointer;
      }
    }
  }
}

.hw-modal-footer {
  padding-top: 30px;
  text-align: center;
}
</style>
